module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD3SURBVHgB7dlRCoJAFEDRZyuoFecOqiW0Qt3BpCgYJd4UmbTuAX8GRLnofLyJkCRJkiT9rZTSubmq/rqEBm2Q9K4Mdfqv5lUVG1DEBrQ1xtaLRnzZITTJQMBAwEDAQMBAwEDAQMBAwEDAQMBAwEDAQMBAwEDAQGBRoKcB+yomnrOWfAcBaXzAvhdlzDR75pu6Yfox9qluxtynOTe4B4ElgW6xX/fIofnNrmnFTTqD9l3LWMBzMeAeBAwEDAQMBAwEDAQMBAwEDAQMBAwEDAQMBAwEDAQMBAwEthKo/nAtu60EGjsIyDNg34s0HAQsHrBLkiRJkn7DA+VocRIPUFygAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plus-white.png
// module id = 703
// module chunks = 0